export default __webpack_public_path__ + "assets/images/ce3e556cd00af7472364d4e7dbd7266c.svg";